import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import bannerSolution from "/public/solution-site-banner.png";

export const SolutionSiteBanner = () => {
  return (
    <div className="relative mx-auto box-border w-full max-w-7xl overflow-hidden">
      <a
        href="https://solution.tocca.systems/"
        target="_blank"
        rel="noopener noreferrer"
        className="group relative block hover:opacity-90 transition-opacity"
      >
        <div className="relative aspect-[1408/768] w-full sm:aspect-[16/9]">
          <Image
            src={bannerSolution}
            alt="トッカシステムズ ソリューションサイト - AI対話型ソリューション提案"
            quality={80}
            layout="fill"
            objectFit="cover"
            priority
          />
          <div className="absolute inset-0 bg-gradient-to-r from-nvy/80 via-nvy/50 to-transparent" />
          <div className="absolute inset-0 flex flex-col justify-center px-6 sm:px-8 md:px-12 lg:px-16">
            <div className="max-w-xl">
              <h6 className="mb-2 text-sm font-bold text-pri md:mb-4 md:text-md">
                Solution Site
              </h6>
              <h3 className="mb-2 font-bold text-white fluid-text-[18px,32px] md:mb-4">
                AI対話型ソリューション提案
              </h3>
              <p className="mb-4 text-white/90 fluid-text-[12px,16px] md:mb-6">
                お客様のビジネス課題に最適なソリューションを、
                <br className="hidden sm:block" />
                AIとの対話を通じてご提案します。
              </p>
              <span className="inline-flex items-center gap-2 rounded-md bg-pri px-4 py-2 text-sm font-bold text-white transition-colors group-hover:bg-pri/80 md:px-6 md:py-3 md:text-base">
                ソリューションサイトへ
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="text-xs" />
              </span>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};
